var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePaimentFacture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2859 28.2858C28.2859 28.695 28.1233 29.0874 27.834 29.3767C27.5446 29.6661 27.1522 29.8286 26.743 29.8286H12.8573C12.4481 29.8286 12.0557 29.6661 11.7663 29.3767C11.477 29.0874 11.3145 28.695 11.3145 28.2858V11.3143C11.3145 10.9052 11.477 10.5127 11.7663 10.2234C12.0557 9.93403 12.4481 9.77148 12.8573 9.77148H22.8859L28.2859 15.1715V28.2858Z",
    stroke: "#38C3FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1152 9.77148V15.9429H28.2867",
    stroke: "#38C3FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 26.295C19.6848 26.4314 19.3444 26.5012 19.0005 26.5C18.2386 26.465 17.5217 26.1297 17.0064 25.5676C16.491 25.0054 16.2193 24.262 16.2505 23.5C16.2193 22.738 16.491 21.9947 17.0064 21.4325C17.5217 20.8703 18.2386 20.5351 19.0005 20.5C19.2778 20.4985 19.5534 20.5441 19.8155 20.635",
    stroke: "#38C3FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H18",
    stroke: "#38C3FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.25H18",
    stroke: "#38C3FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePaimentFacture);
export default __webpack_public_path__ + "static/media/imagePaimentFacture.baab7f1b200ae70112957022cc5110a0.svg";
export { ForwardRef as ReactComponent };